import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HelperService } from 'src/app/services/helper.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { doc } from '@angular/fire/firestore';
import { snapshot$ } from 'src/firebase-utils';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatBadge } from '@angular/material/badge';
import { AppsComponent } from '../../../menus/apps/apps.component';
import { NotificationsComponent } from '../../../menus/notifications/notifications.component';
import { UserComponent } from '../../../menus/user/user.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [MatToolbar, MatIconButton, MatIcon, MatTooltip, MatMenuTrigger, MatBadge, MatMenu, AppsComponent, NotificationsComponent, UserComponent]
})
export class HeaderComponent implements OnInit {
  auth = inject(AuthService);
  helper = inject(HelperService);


  user: any = undefined
  menuState = 'expanded'
  notifications: Number = 0

  notificationsService = inject(NotificationsService)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  ngOnInit(): void {

    this.auth.user$.subscribe((response) => {
      this.user = response
    })

    let interval = setInterval(() => {
      if(this.user) {
        clearInterval(interval)

        const docRef = doc(this.notificationsService.notificationRef, this.user.uid)
        snapshot$(docRef).subscribe((response) => {
          this.notifications = Object.values(response).filter((notification: any) => notification.read == false).length
        })
      }
    }, 100)
  }

  toggleMenu() {
    if(this.menuState == 'expanded') {
      this.menuState = 'minified'

      this.helper.sidenav = 0
      
    } else {
      this.menuState = 'expanded'
      this.helper.sidenav = 1
    }
  }

}
